import React, { useCallback, useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
    Box,
    Button,
    Typography,
    MenuItem,
    Menu,
    Chip,
    IconButton,
    Divider,
    Skeleton,
    TextareaAutosize,
    Tooltip,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { config, styles } from "../../style";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { query, describe, create, update } from "../../services/salesforce";
import InfoIcon from "@mui/icons-material/Info";
import { use } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectSpeakerSearchData, setSpeakerNotes } from "./speakerSearchSlice";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { format } from "date-fns";
import TextToggle from "../../components/TextToggle";
import ReactShowMoreText from "react-show-more-text";
import { relativeDates } from "../../utils/date";
import { saveNotesAsync } from "./speakerSearchSlice";

export const Comments = (props) => {
    const data = useSelector(selectSpeakerSearchData);
    const dispatch = useDispatch();

    const {
        speakerId,
        userDetails,
        initialRecordCount = 3,
        errorIfNoComments,
        hideLabel,
        handleEditCommentModalOpen = () => {},
        handleDeleteComment = () => {},
        inSideSpeakerCard,
        onOpenSpeakerModal = () => {},
    } = props;
    const [localComments, setLocalComments] = useState([]);
    const [expectedRecordCount, setExpectedRecordCount] = useState(3);
    const [selectedComment, setSelectedComment] = useState(null);

    const [otherAnchorEl, setOtherAnchorEl] = React.useState(null);
    const otherOption = Boolean(otherAnchorEl);
    const commentContainerRef = useRef();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (data.speakerComments && data.speakerComments[speakerId]) {
            if (data.speakerComments[speakerId] === "Loading") {
                setLoading(true);
            } else {
                setLocalComments([...data.speakerComments[speakerId]]);
                // if (!inSideSpeakerCard) {
                //     handleLoadMore();
                // }
                setLoading(false);
            }
        }
    }, [data.speakerComments]);

    useEffect(() => {
        if (!inSideSpeakerCard) {
            setTimeout(() => {
                document.querySelector(`.load-more-${speakerId}-outside`)?.click();
            }, 500);
        }
    }, [inSideSpeakerCard]);

    const handleLoadMore = () => {
        if (inSideSpeakerCard) {
            onOpenSpeakerModal();
            return;
        }
        let expected = expectedRecordCount + 10;
        setExpectedRecordCount(expected);

        if (expectedRecordCount >= localComments.length && expected > localComments.length) {
            query("portalNote", "getRecords", {
                speakerId: speakerId,
                lastId: localComments?.length > 0 ? localComments[localComments.length - 1].id : undefined,
                accountId: userDetails?.contact?.accountId,
            }).then((result) => {
                if (result.isSuccess) {
                    let records = [...localComments, ...result.data];
                    setLocalComments(records);
                    dispatch(
                        setSpeakerNotes({
                            speakerId: speakerId,
                            comments: records,
                        })
                    );
                }
                setLoading(false);
            });
        }
    };

    const handleShowLess = () => {
        setExpectedRecordCount(3);
    };

    const getDisplayComments = () => {
        return inSideSpeakerCard
            ? localComments.filter((item, index) => index < expectedRecordCount - 1)
            : localComments;
    };

    const handleEditComment = (comment) => {
        handleEditCommentModalOpen(comment);
        console.log("Edit Comment");
    };

    const handleMenuClick = (event, comment) => {
        setOtherAnchorEl(event.currentTarget);
        setSelectedComment(comment);
    };

    const handleOtherMenuClose = (action) => {
        if (action === "edit") {
            handleEditComment(selectedComment);
        } else if (action === "delete") {
            setExpectedRecordCount(expectedRecordCount - 1);
            handleDeleteComment(selectedComment);
        }
        setOtherAnchorEl(null);
    };

    const commentActionUI = (comment) => {
        return (
            <>
                <Button
                    id="filter-speakers1"
                    aria-controls={otherOption ? "basic-menu1" : undefined}
                    aria-haspopup="true"
                    aria-expanded={otherOption ? "true" : undefined}
                    onClick={(e) => {
                        handleMenuClick(e, comment);
                    }}
                    sx={{
                        ...styles.outlinedButton,
                        borderRadius: "4px",
                        padding: "0",
                        minWidth: "20px",
                        marginLeft: "8px",
                        // paddingLeft: "10px",
                    }}
                    disabled={comment.contactId === userDetails?.contact?.id && comment.id ? false : true}
                    variant="outlined">
                    <MoreVertIcon
                        fontSize="12px"
                        sx={{
                            color:
                                comment.contactId === userDetails?.contact?.id && comment.id
                                    ? config.primaryColor
                                    : "gray",
                            transform: "rotate(90deg)",
                        }}
                    />
                </Button>
                <Menu
                    id="basic-menu1"
                    anchorEl={otherAnchorEl}
                    open={otherOption}
                    onClose={() => handleOtherMenuClose("")}
                    MenuListProps={{
                        "aria-labelledby": "filter-speakers1",
                    }}
                    sx={{
                        "& .MuiMenuItem-root:hover": {
                            background: "#F7F6FE",
                        },
                    }}>
                    <MenuItem onClick={() => handleOtherMenuClose("edit")} value="view-profile">
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                            }}>
                            <BorderColorIcon
                                fontSize="12px"
                                sx={{
                                    color: config.primaryColor,
                                    mr: "10px",
                                }}></BorderColorIcon>
                            Edit Comment
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={() => handleOtherMenuClose("delete")} value="request-fee">
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                            }}>
                            <DeleteOutlineIcon
                                fontSize="12px"
                                sx={{
                                    color: config.primaryColor,
                                    mr: "10px",
                                }}></DeleteOutlineIcon>
                            Delete Comment
                        </Box>
                    </MenuItem>
                </Menu>
            </>
        );
    };

    const [newCommentValue, setNewCommentValue] = useState("");
    const onCommentSave = () => {
        const newComment = {
            id: "",
            description: newCommentValue,
            speakerId: speakerId,
            contactId: userDetails?.contact?.id,
            contactName: userDetails?.contact?.name,
            accountId: userDetails?.contact?.accountId,
        };
        setNewCommentValue("");
        dispatch(saveNotesAsync({ note: newComment }));
    };
    return (
        <>
            <Box>
                {!hideLabel && (
                    <Typography
                        sx={{
                            color: "#344054",
                            fontSize: "14px",
                            fontWeight: 600,
                            marginBottom: "8px",
                        }}>
                        Comments{" "}
                        <Tooltip title="Comments on a speaker are visible to your team and WSB.">
                            <IconButton sx={{ p: 0 }}>
                                <InfoIcon sx={{ width: "18px" }}></InfoIcon>
                            </IconButton>
                        </Tooltip>
                    </Typography>
                )}
                {loading && <Skeleton variant="rectangular" sx={{ borderRadius: "8px" }} height={40} />}
                {!loading && (
                    <>
                        <Box marginBottom={"5px"} sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                            <Box
                                component={TextareaAutosize}
                                onChange={(event) => {
                                    setNewCommentValue(event.target.value);
                                }}
                                value={newCommentValue}
                                aria-label="empty textarea"
                                placeholder="Add your comment here..."
                                sx={{
                                    border: `1px solid #EEF4FF`,
                                    background: "#F5F8FF",
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    padding: "0.5rem",
                                    width: "100%",
                                    fontFamily: "inherit",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                    // maxWidth: "100%",
                                    // minWidth: "100%",
                                    // minHeight: "40px",
                                    resize: "none",

                                    // maxHeight:"119px",
                                    // overflow:"auto",

                                    /* Style for the placeholder text */
                                    "&::placeholder ": {
                                        color: "#70707B" /* Placeholder text color */,
                                        fontStyle: "italic" /* Placeholder text style */,
                                        opacity: 0.8 /* Ensure visibility (1 = fully visible) */,
                                    },
                                }}
                                minRows={1}
                            />
                            {newCommentValue && (
                                <Button
                                    variant="contained"
                                    sx={{
                                        maxHeight: "40px",
                                        padding: "6px 12px",
                                        marginTop: {
                                            xs: "0.5rem",
                                            sm: "0",
                                        },
                                        width: {
                                            xs: "100%",
                                            sm: "unset",
                                        },
                                        // float: "right",
                                    }}
                                    onClick={onCommentSave}>
                                    Save
                                </Button>
                            )}
                        </Box>
                        {getDisplayComments().map((comment, index) => (
                            <>
                                {index + 1 !== expectedRecordCount && (
                                    <Box
                                        sx={{
                                            borderRadius: "8px",
                                            border: "1px solid #EEF4FF",
                                            padding: "6px 10px",
                                            background: "#F5F8FF",
                                            mb: "5px",
                                            paddingBottom: "11px",
                                        }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                minHeight: "26px",
                                            }}>
                                            <Typography
                                                sx={{
                                                    color: "#51525C",
                                                    fontSize: "14px",
                                                    fontWeight: 600,
                                                    lineHeight: "20px" /* 142.857% */,
                                                }}>
                                                {comment.contactName}
                                                {comment.contactId === userDetails?.contact?.id && " (You)"}
                                            </Typography>
                                            {comment.id && (
                                                <Box
                                                    className="actions"
                                                    sx={{
                                                        justifyContent: "end",
                                                        alignItems: "center",
                                                        display: "flex",
                                                    }}>
                                                    <Typography
                                                        sx={{ fontSize: "12px", color: "#8a8a8a" }}
                                                        title={format(
                                                            new Date(comment.createdDate),
                                                            "MMM dd, yyyy hh:mm a"
                                                        )}>
                                                        {relativeDates(new Date(comment.createdDate))}
                                                    </Typography>

                                                    {comment.contactId === userDetails?.contact?.id && comment.id
                                                        ? commentActionUI(comment, index)
                                                        : null}
                                                </Box>
                                            )}
                                        </Box>

                                        <Typography
                                            ref={commentContainerRef}
                                            sx={{
                                                color: "#70707B",
                                                fontSize: "12.5px",
                                                fontWeight: 400,
                                                lineHeight: "20px" /* 142.857% */,
                                            }}>
                                            {
                                                <TextToggle
                                                    parentRef={commentContainerRef}
                                                    text={comment.description}
                                                    maxLines={2}></TextToggle>
                                            }
                                        </Typography>
                                    </Box>
                                )}
                            </>
                        ))}
                        {(expectedRecordCount - 1 < localComments.length ||
                            (!inSideSpeakerCard && expectedRecordCount === localComments.length)) && (
                            <Button
                                variant="text"
                                className={`load-more-${speakerId}-${!inSideSpeakerCard ? "outside" : "inside"}`}
                                onClick={handleLoadMore}
                                startIcon={<KeyboardArrowDown />}
                                sx={{
                                    padding: 0,

                                    color: "rgba(45, 42, 85, 0.60)",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    lineHeight: "160%", // Equivalent to 19.2px

                                    "& .MuiButton-startIcon": {
                                        marginRight: "4px",
                                    },
                                    "&:hover": {
                                        background: "none",
                                    },
                                }}>
                                {"Load more comments"}
                            </Button>
                        )}

                        {inSideSpeakerCard && getDisplayComments()?.length > 2 && (
                            <Button
                                variant="text"
                                onClick={handleShowLess}
                                startIcon={<KeyboardArrowUp />}
                                sx={{
                                    padding: 0,

                                    color: "rgba(45, 42, 85, 0.60)",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    lineHeight: "160%", // Equivalent to 19.2px

                                    "& .MuiButton-startIcon": {
                                        marginRight: "4px",
                                    },
                                    "&:hover": {
                                        background: "none",
                                    },
                                }}>
                                {"Show less"}
                            </Button>
                        )}
                    </>
                )}
            </Box>
        </>
    );
};
